export default __webpack_public_path__ + "static/media/Fleet.3fc78c7c.svg";